export function normalizeValue(value) {
  return value == null ? "" : String(value).trim();
}

export function asDate(ymd) {
  const value = normalizeValue(ymd);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return null;
  }
  return new Date(`${value}T00:00:00Z`);
}

export function isBetween(target, begin, end) {
  const targetDate = asDate(target);
  const beginDate = asDate(begin);
  const endDate = asDate(end);
  if (!targetDate || !beginDate || !endDate) return false;
  return beginDate <= targetDate && targetDate <= endDate;
}

export function isDateGte(target, ymd) {
  const targetDate = asDate(target);
  const baseDate = asDate(ymd);
  if (!targetDate || !baseDate) return false;
  return targetDate >= baseDate;
}

export function boolFromJa(value) {
  return normalizeValue(value) === "はい";
}
